var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'nuxt-class-component';
import ENDPOINTS from 'services/ENDPOINTS';
import { Watch } from 'vue-property-decorator';
import { OrderAction } from 'store/index';
var MapMixin = (function (_super) {
    __extends(MapMixin, _super);
    function MapMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetchOrderData = true;
        _this.isNormalCar = null;
        _this.start = null;
        _this.finish = null;
        _this.queryStart = null;
        _this.queryFinish = null;
        _this.place = null;
        _this.center = { lat: 60.198545, lng: 24.948578 };
        _this.loaded = false;
        _this.startRouteService = false;
        _this.polyline = null;
        _this.map = null;
        _this.loadPointByAddress = false;
        return _this;
    }
    MapMixin.prototype.onIdle = function () {
        this.loaded = true;
    };
    MapMixin.prototype.offIdle = function () {
        this.loaded = false;
    };
    MapMixin.prototype.onChangeQueryStartPoint = function (val) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!val) return [3, 2];
                        this.loadPointByAddress = true;
                        return [4, this.$axios.$get(ENDPOINTS.ORDER.GEOCODE, {
                                params: {
                                    address: val
                                }
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        if (data) {
                            this.setStart(data);
                        }
                        else {
                            this.start = null;
                        }
                        this.loadPointByAddress = false;
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    MapMixin.prototype.onChangeQueryFinishPoint = function (val) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!val) return [3, 2];
                        this.loadPointByAddress = true;
                        return [4, this.$axios.$get(ENDPOINTS.ORDER.GEOCODE, {
                                params: {
                                    address: val
                                }
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        if (data) {
                            this.setFinish(data);
                        }
                        else {
                            this.finish = null;
                        }
                        this.loadPointByAddress = false;
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    MapMixin.prototype.onLoadMap = function () {
        if (typeof window !== 'undefined') {
            this.initMap();
            this.startRouteService = true;
        }
    };
    MapMixin.prototype.initMap = function () {
        this.map = this.$refs.map.$mapObject;
        this.map.setOptions({
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false
        });
        this.directionsDisplay = new window.google.maps.DirectionsRenderer();
        this.directionsDisplay.setMap(this.map);
    };
    MapMixin.prototype.resetRoute = function () {
        this.initMap();
        this.isNormalCar = null;
        this.start = this.finish = null;
        this.queryFinish = this.queryStart = null;
        this.setShowOrderPrice(false);
        if (this.polyline) {
            this.polyline.setMap(null);
        }
    };
    MapMixin.prototype.getRoute = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.start || !this.finish) {
                            return [2, false];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.$axios.$get(ENDPOINTS.ORDER.SHIPPING_INFO, {
                                params: {
                                    origin: this.start.position.address,
                                    destination: this.finish.position.address,
                                    is_normal_car: this.isNormalCar
                                }
                            })];
                    case 2:
                        data = (_a.sent()).data;
                        if (data) {
                            if (this.fetchOrderData) {
                                this.fetchShippingInfo(data);
                            }
                            this.polyline = this.drawPolyline(this.map, data.route_polyline);
                            this.fitMapBounds(this.map, data.bounds);
                        }
                        return [2, true];
                    case 3:
                        e_1 = _a.sent();
                        this.$toast.error(this.$t('messages.error.direction_request') + ': ' + e_1.status);
                        return [2, false];
                    case 4: return [2];
                }
            });
        });
    };
    MapMixin.prototype.setStart = function (place) {
        this.setPlacePoint(place, 'start');
    };
    MapMixin.prototype.setStartPoint = function (street, city, postal_code, lat, lng) {
        this.setPoint('start', street, city, postal_code, lat, lng);
    };
    MapMixin.prototype.setFinish = function (place) {
        this.setPlacePoint(place, 'finish');
    };
    MapMixin.prototype.setFinishPoint = function (street, city, postal_code, lat, lng) {
        this.setPoint('finish', street, city, postal_code, lat, lng);
    };
    MapMixin.prototype.setPoint = function (name, street, city, postal_code, lat, lng) {
        var address = street + ', ' + postal_code + ' ' + city;
        this[name] = {
            position: {
                address: address,
                street: street,
                city: city,
                postal_code: postal_code,
                lat: lat,
                lng: lng
            }
        };
    };
    MapMixin.prototype.setPlacePoint = function (place, name) {
        if (!place || !place.lng || !place.lat) {
            this[name] = null;
            return false;
        }
        this.place = place;
        if (this.place && this.place.lng && this.place.lat) {
            this.center = {
                lat: this.place.lat,
                lng: this.place.lng
            };
            this[name] = {
                position: this.place
            };
        }
        else {
            this.$toast.error(this.$t('messages.error.invalid_location'));
        }
    };
    MapMixin.prototype.drawPolyline = function (map, newPolilyne) {
        if (map) {
            if (this.polyline) {
                this.polyline.setMap(null);
            }
            return new window.google.maps.Polyline({
                path: window.google.maps.geometry.encoding.decodePath(newPolilyne),
                map: map,
                strokeColor: '#6495ed',
                strokeWeight: 4
            });
        }
    };
    MapMixin.prototype.fitMapBounds = function (map, boundsLatLng) {
        if (map) {
            var bounds = new window.google.maps.LatLngBounds();
            this.extendBounds(bounds, boundsLatLng);
            map.fitBounds(bounds);
        }
    };
    MapMixin.prototype.extendBounds = function (bounds, boundsLatLng) {
        bounds.extend(this.getCoords(boundsLatLng.northeast));
        bounds.extend(this.getCoords(boundsLatLng.southwest));
    };
    MapMixin.prototype.getCoords = function (place) {
        return new window.google.maps.LatLng(place.lat, place.lng);
    };
    __decorate([
        OrderAction('FETCH_ORDER')
    ], MapMixin.prototype, "fetchShippingInfo", void 0);
    __decorate([
        OrderAction('SHOW_ORDER_PRICE')
    ], MapMixin.prototype, "setShowOrderPrice", void 0);
    __decorate([
        Watch('queryStart', { deep: true })
    ], MapMixin.prototype, "onChangeQueryStartPoint", null);
    __decorate([
        Watch('queryFinish', { deep: true })
    ], MapMixin.prototype, "onChangeQueryFinishPoint", null);
    __decorate([
        Watch('loaded')
    ], MapMixin.prototype, "onLoadMap", null);
    MapMixin = __decorate([
        Component
    ], MapMixin);
    return MapMixin;
}(Vue));
export default MapMixin;



//////////////////
// WEBPACK FOOTER
// ./mixins/map.ts
// module id = ./mixins/map.ts
// module chunks = 0 1 3 5